import * as React from 'react';
import styled from 'styled-components';

export default class Card extends React.Component {

  render() {
    return (
      <CardView>
        <Content>
          {this.props.children}
        </Content>
      </CardView>
    );
  }
}
const CardView = styled.div`
  border-radius: 1.563em;
`;

const Content = styled.div`
  padding: 2em 2em 3em 2em;
`;